import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const CSRComplianceAdvisory = () => {
  const serviceData = {
    title: "CSR Compliance Advisory",
    heading: "CSR Compliance Advisory",
    image: subTopicImages["CSR Compliance Advisory"],
    intro: "",
    description: [
      "CSR today carries both legal responsibility and social purpose.",
      "We assist companies in managing CSR obligations under the Companies Act in a compliant and well-governed manner.",
    ],
    services: [
      {
        title: "Our Services Include",
        list: [
          "CSR policy development & Board advisory",
          "identifying and reviewing CSR projects",
          "utilisation tracking & documentation",
          "CSR disclosures and MCA compliance",
        ],
        extraInfo:
          "We ensure CSR programs are law-compliant, transparent and purpose-driven.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default CSRComplianceAdvisory;
